var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGynecologist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "16px",
    viewBox: "0 0 9 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-gynecologist",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 1.000000)",
    fill: "#212529",
    fillRule: "nonzero",
    id: "\\uF221"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,4.5 C9,5.60416667 8.640625,6.57291667 7.921875,7.40625 C7.203125,8.23958333 6.3125,8.75 5.25,8.9375 L5.25,10.75 L6.625,10.75 C6.875,10.75 7,10.875 7,11.125 L7,11.875 C7,12.125 6.875,12.25 6.625,12.25 L5.25,12.25 L5.25,13.625 C5.25,13.875 5.125,14 4.875,14 L4.125,14 C3.875,14 3.75,13.875 3.75,13.625 L3.75,12.25 L2.375,12.25 C2.125,12.25 2,12.125 2,11.875 L2,11.125 C2,10.875 2.125,10.75 2.375,10.75 L3.75,10.75 L3.75,8.9375 C2.6875,8.75 1.796875,8.23958333 1.078125,7.40625 C0.359375,6.57291667 0,5.60416667 0,4.5 C0,3.25 0.4375,2.1875 1.3125,1.3125 C2.1875,0.4375 3.25,0 4.5,0 C5.75,0 6.8125,0.4375 7.6875,1.3125 C8.5625,2.1875 9,3.25 9,4.5 Z M2.375,2.375 C1.79166667,2.95833333 1.5,3.66666667 1.5,4.5 C1.5,5.33333333 1.79166667,6.04166667 2.375,6.625 C2.95833333,7.20833333 3.66666667,7.5 4.5,7.5 C5.33333333,7.5 6.04166667,7.20833333 6.625,6.625 C7.20833333,6.04166667 7.5,5.33333333 7.5,4.5 C7.5,3.66666667 7.20833333,2.95833333 6.625,2.375 C6.04166667,1.79166667 5.33333333,1.5 4.5,1.5 C3.66666667,1.5 2.95833333,1.79166667 2.375,2.375 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGynecologist);
export default __webpack_public_path__ + "static/media/icon-gynecologist.b6cb5e3c04210fb640c2a37a0bb37bab.svg";
export { ForwardRef as ReactComponent };